import React from 'react';
import Icon from '../../../components/AppIcon';

const ConversationList = ({ conversations, selectedConversation, onSelectConversation }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math?.floor(diffMs / 60000);
    const diffHours = Math?.floor(diffMs / 3600000);
    const diffDays = Math?.floor(diffMs / 86400000);

    if (diffMins < 1) return 'À l\'instant';
    if (diffMins < 60) return `Il y a ${diffMins}min`;
    if (diffHours < 24) return `Il y a ${diffHours}h`;
    if (diffDays < 7) return `Il y a ${diffDays}j`;
    return date?.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
  };

  const truncateMessage = (message, maxLength = 60) => {
    if (!message) return '';
    return message?.length > maxLength ? `${message?.substring(0, maxLength)}...` : message;
  };

  if (!conversations || conversations?.length === 0) {
    return (
      <div className="p-8 text-center">
        <Icon name="Inbox" size={48} className="text-muted-foreground opacity-20 mx-auto mb-3" />
        <p className="text-muted-foreground">Aucune conversation</p>
      </div>
    );
  }

  return (
    <div className="overflow-y-auto" style={{ maxHeight: '600px' }}>
      {conversations?.map((conversation) => (
        <button
          key={conversation?.client?.id}
          onClick={() => onSelectConversation(conversation)}
          className={`w-full p-4 border-b border-border hover:bg-muted/50 transition-colors text-left ${
            selectedConversation?.client?.id === conversation?.client?.id
              ? 'bg-primary/5 border-l-4 border-l-primary' :''
          }`}
        >
          <div className="flex items-start gap-3">
            {/* Avatar */}
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              {conversation?.client?.avatar_url ? (
                <img
                  src={conversation?.client?.avatar_url}
                  alt={conversation?.client?.full_name || 'Client'}
                  className="w-full h-full rounded-full object-cover"
                />
              ) : (
                <Icon name="User" size={24} className="text-primary" />
              )}
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <h4 className="font-semibold text-foreground truncate">
                  {conversation?.client?.full_name || 'Client'}
                </h4>
                <span className="text-xs text-muted-foreground ml-2 flex-shrink-0">
                  {formatDate(conversation?.lastMessage?.createdAt)}
                </span>
              </div>
              
              <p className="text-sm text-muted-foreground truncate mb-1">
                {truncateMessage(conversation?.lastMessage?.message)}
              </p>
              
              <div className="flex items-center gap-2">
                <span className="text-xs text-muted-foreground">
                  {conversation?.messageCount} message{conversation?.messageCount > 1 ? 's' : ''}
                </span>
                {conversation?.unreadCount > 0 && (
                  <span className="bg-primary text-white text-xs px-2 py-0.5 rounded-full">
                    {conversation?.unreadCount}
                  </span>
                )}
              </div>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default ConversationList;
